import { FieldValues } from 'react-hook-form';

export const validateCarCreation = async (values: FieldValues): Promise<FieldValues> => {
  const errors: FieldValues = {};

  validateForRent(values, errors);
  validateForSell(values, errors);

  console.log(errors)
  return errors;
};

const validateForRent = (values: FieldValues, errors: FieldValues): FieldValues => {
  if (!values.isForRent) {
    return errors;
  }

  if (values.priceFirst <= 0) {
    errors.priceFirst = 'Price First must be greater than 0 when the car is for rent';
  }

  if (values.priceSecond <= 0) {
    errors.priceSecond = 'Price Second must be greater than 0 when the car is for rent';
  }

  if (values.priceThird <= 0) {
    errors.priceThird = 'Price Third must be greater than 0 when the car is for rent';
  }

  if (values.priceFourth <= 0) {
    errors.priceFourth = 'Price Fourth must be greater than 0 when the car is for rent';
  }

  return errors;
}

const validateForSell = (values: FieldValues, errors: FieldValues): FieldValues => {
  if (!values.isForSell) {
    return errors;
  }

  if (values.carSellPrice <= 0) {
    errors.carSellPrice = 'Car sell price must be greater than 0 when the car is for sell';
  }

  return errors;
}